import { api_url } from "@/config/api_url";
import axios from 'axios';
import { defineStore } from "pinia";
import { useNotificationStore } from "./notificationStore";
import { usePolylineWorker } from '@/workers/usePolylineWorker'
import { nextTick } from "vue";


export const usePlayMissionStore = defineStore('playMissionStore',{
    state:() => ({
        missions:[],
        missionToFollow:{},
        indexVehicleToFollow:0,
        chargeText:"",
        loading_mission:false,
        session_id:""
    }),

    actions:{

        addPlayMission(new_mission){
            this.missions.push(new_mission);
        },

        async startPlayMission(new_mission,interval,recordsType,isActive){
            this.chargeText = "Loading...";     
            new_mission.start_date = new Date(new_mission.start_date).getTime();
            new_mission.end_date = new Date(new_mission.end_date).getTime() + interval * 1000;
            new_mission.current_playing_date = new_mission.start_date;

            new_mission.start_time_ms = new_mission.current_playing_date;
            new_mission.current_playing = isActive;
            new_mission.finished = false;
            new_mission.is_loading = true;
            new_mission.closing = false;

            new_mission.recording_interval = 1000;                  //Max number of records per vehicle
            new_mission.current_playing_record = 0;                 
            new_mission.interval = interval;
            new_mission.total_intervals = Math.floor(
                (new Date(new_mission.end_date).getTime() - new Date(new_mission.start_date).getTime()) / (interval*1000)
            );             //Numero de posibles intervalos ficticios


            new_mission.recordsType = recordsType;
            try {
                //Solicito el tiempo inicial y final de todos los vehículos
                this.chargeText = "Loading vehicles timestamps from mission "+new_mission.name + "...";
                const timestamps = await this.getTimestampsFromMission(new_mission.id, recordsType);
                let checkRecords = false;
                for (let obj of timestamps) {
                    let start = obj.start;
                    let end = obj.end;
                    if (start || end) {
                        checkRecords = true;
                    }
                }
                if (!checkRecords) {
                    useNotificationStore().setNotification("Error", "The mission has no records with that kind of data.", "mdi-alert-circle-outline", "error");
                    return false;
                }
        
                for (let obj of timestamps) {
                    let vehicle_id = obj.vehicle_id;
                    let start = obj.start;
                    let end = obj.end;
                    let start_date = new Date(start).getTime();
                    let end_date = new Date(end).getTime();
                    let index = new_mission.vehicles.findIndex((vehicle) => vehicle.id == vehicle_id);
                    this.chargeText = "Loading records from vehicle "+new_mission.vehicles[index].name + "...";
                    const {records,meta} = await this.getMissionRecords(new_mission.id, vehicle_id, isActive ? end_date: start_date,start_date,end_date, recordsType, interval);

                    let fields = this.checkFields(new_mission.vehicles[index]);
                    new_mission.vehicles[index].start_date = start_date
                    new_mission.vehicles[index].end_date = end_date;
                    new_mission.vehicles[index].P = 0; //Cursor
                    new_mission.vehicles[index].W = 0; //Cursor waypoints
                    new_mission.vehicles[index].fields = fields;
                    new_mission.vehicles[index].size = 30;
                    new_mission.vehicles[index].isClosed = false;
                    new_mission.vehicles[index].records = records;
                    new_mission.vehicles[index].meta = meta;
                    new_mission.vehicles[index].timestamps = records.map(r => new Date(r[fields.timeKey]).getTime());

                    const polylineWorkerFn = usePolylineWorker();
                    const result = await polylineWorkerFn(JSON.stringify(records), interval, JSON.stringify(fields));
                    new_mission.vehicles[index].latLngs = result;                    
                    new_mission.vehicles[index].waypoints = [];
                    let waypoints = await this.getWaypointsFromMission(new_mission.id,vehicle_id);
                    new_mission.vehicles[index].waypoints.push(...waypoints);
                    new_mission.vehicles[index].timestampsWaypoints = waypoints.map(r => r.timestamp);
                    new_mission.vehicles[index].latLngsWaypoints =   waypoints.map(waypoint => this.convertWaypointToArray(waypoint))
                }

                
                
                this.addPlayMission(new_mission);
                return true;
            } catch (error) {
                console.log(error);
                useNotificationStore().setNotification("Error", "Error while trying to play the mission. It may be related to a descriptive error—try editing the vehicle's description file.", "mdi-alert", "red");
                return false;
            }
        
        },

        convertWaypointToArray(waypoint){
            return waypoint.latitudes.map((lat, i) => [lat, waypoint.longitudes[i]])
        },

        async getWaypointsFromMission(mission_id,vehicle_id){
            try{
                const waypointsResponse = await axios.get(`${api_url}/getWaypointsFromMission/${mission_id}/${vehicle_id}`);
                if (waypointsResponse.data.length != 0) {
                    const waypoints = [];
                    waypointsResponse.data.forEach(value => {
                        value.nodes = JSON.parse(value.nodes);
                        value.latitudes = JSON.parse(value.latitudes);
                        value.longitudes = JSON.parse(value.longitudes);
                        value.is_cyclic = value.is_cyclic === 1;
                        value.timestamp = new Date(value.timestamp).getTime();
                        waypoints.push(value);
                    })
                    return waypoints;
                }
                return [];
            }catch(error){
                useNotificationStore().setNotification("Error", error, "mdi-alert", "red");
            }


        },

        async nextPage(mission_id,vehicle_id,timestamp,recordsType,interval){
            try{
                this.chargeText = "Loading...";
                const index = this.missions.findIndex((mission)=>mission.id==mission_id);
                //this.missions[index].is_loading = true;
                const index_vehicle = this.missions[index].vehicles.findIndex((vehicle)=>vehicle.id==vehicle_id);
                // let lastRecords = this.missions[index].vehicles[index_vehicle].records;
                // this.missions[index].vehicles[index_vehicle].lastRecord = lastRecords[this.missions[index].vehicles[index_vehicle].P];
                let start_date = this.missions[index].vehicles[index_vehicle].start_date;
                let end_date = this.missions[index].vehicles[index_vehicle].end_date;
                this.chargeText = "Loading records from vehicle "+ this.missions[index].vehicles[index_vehicle].name + "...";
                const {records,meta} = await this.getMissionRecords(
                    mission_id,
                    vehicle_id,
                    timestamp,
                    start_date,
                    end_date,
                    recordsType,
                    interval);


                const fields = this.missions[index].vehicles[index_vehicle].fields;



                //Si la respuesta no recupera ningún registro reciente al tiempo timestamp,
                //  mando peticiones ampliando el tamaño del intervalo para encontrar algun bloque antiguo a P que tenga un registro mas reciente al tiempo timestamp
                if(records.length==0 || new Date(records[0][fields.timeKey]).getTime()>timestamp){
                    let recentRecords = [];
                    let timestampMin = Math.min(timestamp,end_date);
                    let factor = 2;
                    while(timestampMin>=start_date && recentRecords.length==0){
                        this.chargeText = "Get last records from vehicle "+ this.missions[index].vehicles[index_vehicle].name + "...";
                        console.log("Cargando last records"+this.missions[index].vehicles[index_vehicle].name)
                        const {records} = await this.getRecentRecords(mission_id,vehicle_id,start_date,timestampMin,recordsType,interval,factor,fields.timeKey);
                        recentRecords = records;
                        if(recentRecords.length==0){
                            if(factor>=10){
                                factor += 2;
                            } else{
                                factor += 1;
                            }
                            
                        }else{
                            timestampMin = new Date(recentRecords[0][fields.timeKey]).getTime();
                        }
                    }

                    records.unshift(...recentRecords);
                }



                this.missions[index].vehicles[index_vehicle].records = records;
                this.missions[index].vehicles[index_vehicle].meta = meta;
                this.missions[index].vehicles[index_vehicle].timestamps = records.map(r => new Date(r[fields.timeKey]).getTime());

                const polylineWorkerFn = usePolylineWorker();
                const result = await polylineWorkerFn(JSON.stringify(records), interval, JSON.stringify(fields));

                this.missions[index].vehicles[index_vehicle].latLngs = result; 

                //this.missions[index].is_loading = false;
            }catch(error){
                console.log(error)
                useNotificationStore().setNotification("Error", error, "mdi-alert", "red");
                return false;
            }
        },

        async closeMission(id){
            try {
                
                this.checkIfMissionClosed(id,()=>{
                    console.log("Cerrando mission");
                    this.missions = this.missions.filter(m => m.id !== id);
                })
                await nextTick();
            } catch (e) {
                console.error("Error al cerrar misión:", e);
                //throw e; 
            }
        },


        checkIfMissionClosed(id, callback) {
            let index = this.missions.findIndex(m => m.id === id);
            this.missions[index].closing = true;

            if (index === -1) {
                console.log("No hay misión para cerrar");
                return;
            }

            const check = () => {
                console.log("Intentando cerrar misión...");
                const allClosed = this.missions[index].vehicles.every(vehicle => vehicle.isClosed);

                if (allClosed) {
                //this.missions[index].closing = false;
                console.log("Misión cerrada completamente");
                if (typeof callback === 'function') callback();
                } else {
                setTimeout(check, 1000);
                }
            };

            check();
            },

        async followMissionPosition(mission,vehicle_id){
            this.missionToFollow = mission;
            if(vehicle_id){
                this.indexVehicleToFollow = this.missionToFollow.vehicles.findIndex((vehicle)=>vehicle_id==vehicle.id);
            }
        },

        async getTimestampsFromMission(mission_id,recordsType){
            try{
                const response = await axios
                .get(`${api_url}/getTimestampsFromMission/${mission_id}/${recordsType}`); 
                return response.data;
            }catch(error){
                console.error(e);
            }

        },

        async getMissionRecords(mission_id,vehicle_id,date,start_date,end_date,recordsType,interval){
            return await axios
					.get(`${api_url}/getRecordsFromMission/${mission_id}/${vehicle_id}/${date}/${start_date}/${end_date}/${recordsType}/${interval}`)
					.then((response) => {
                        return response.data;
					})
					.catch((e) => {
						console.error(e);
					});
        },

        async getRecentRecords(mission_id,vehicle_id,start_date,timestamp,recordsType,interval,factor,timeKey){
            return await axios
					.get(`${api_url}/getRecentRecords/${mission_id}/${vehicle_id}/${start_date}/${timestamp}/${recordsType}/${interval}/${factor}/${timeKey}`)
					.then((response) => {
                        return response.data;
					})
					.catch((e) => {
						console.error(e);
					});
        },

        checkFields(vehicle) {
            const descriptive = JSON.parse(vehicle.descriptive);
            const result = {};
        
            for (let key in descriptive) {
                const field = descriptive[key].field;
                if (field) {
                    result[`${field}Key`] = key;
                }
            }
        
            return result;
        },

        checkVisibleFields(vehicle) {
            const descriptive = JSON.parse(vehicle.descriptive);
            const result = [];

            for (let key in descriptive) {
                const field = descriptive[key].field;
                const visible = descriptive[key].visible;
                if (field || visible) {
                    result.push(key);
                }
 
            }

        
            return result;
        },

        addRecordToLiveMission(mission_id, record, vehicle_id) {
            this.missions.forEach(async mission => {
                if (mission.id === mission_id) {
                    let index = mission.vehicles.findIndex((vehicle) => vehicle.id == vehicle_id);
                    if (index === -1) return;


                    let vehicle = mission.vehicles[index];
                    let visibleFields = this.checkVisibleFields(vehicle);
                    let fields = this.checkFields(vehicle);
                    let start_date = new Date(mission.start_date).getTime();
                    let end_date = new Date(record[fields.timeKey]).getTime() + mission.interval * 1000;  

                    mission.end_date = end_date;

                    

                    // Asignar nuevos valores
                    //Limpiar el record
                    let record_clean = {};
                    for(let field of visibleFields){
                        record_clean[field] = record[field];
                    }

                    vehicle.records.push(record_clean); // CORREGIDO
                    vehicle.end_date = new Date(record[fields.timeKey]).getTime();


                    if(mission.current_playing_date < end_date && mission.current_playing_date > new Date(vehicle.records[0][fields.timeKey]).getTime()){
                        const polylineWorkerFn = usePolylineWorker();
                        const result = await polylineWorkerFn(JSON.stringify(vehicle.records), mission.interval, JSON.stringify(fields));
                        mission.vehicles[index].latLngs = result; 
                    }

                    mission.vehicles[index].timestamps = vehicle.records.map(r => new Date(r[fields.timeKey]).getTime());

                    
                    mission.total_intervals = Math.floor((mission.end_date - start_date) / (mission.interval * 1000));
                    mission.vehicles[index] = { ...vehicle };

                    console.log("Paquete de telemetría añadido al vehiculo "+vehicle.name+" :",record_clean);

                    return;
                }
            });
        },

        updateTimeInMission(mission_id,end_date,interval){
            let index = this.missions.findIndex((mission)=>mission.id == mission_id);
            if(index!=-1){
                let start_date = new Date(this.missions[index].start_date).getTime();
                this.missions[index].end_date = end_date;
                this.missions[index].total_intervals = Math.floor((end_date - start_date) / (interval * 1000));
            }
        },

		addWaypointsToLiveMission(mission_id, waypoints, vehicle_id) {
			this.missions.forEach(async mission => {
                if (mission.id === mission_id) {
                    let index = mission.vehicles.findIndex((vehicle) => vehicle.id == vehicle_id);
                    let waypoint = {
						nodes : JSON.parse(waypoints.nodes),
						latitudes : JSON.parse(waypoints.latitudes),
						longitudes : JSON.parse(waypoints.longitudes),
						is_cyclic : waypoints.is_cyclic,
						timestamp : waypoints.timestamp
					}
                    mission.vehicles[index].waypoints.push(waypoint);
                    mission.vehicles[index].latLngsWaypoints.push(this.convertWaypointToArray(waypoint));
                    mission.vehicles[index].timestampsWaypoints.push(new Date(waypoint.timestamp).getMilliseconds())
                }
            });
 
		},


        
        handleError(error) {
            useNotificationStore().setNotification('Error', error.response.data, 'mdi-alert', 'error');
        },
    }
})